module.exports = __webpack_public_path__ + "assets/img/places2.1abf065c.jpg";